<template>
  <div>
    <h1><router-link to="/">LOST IN SPACE</router-link></h1>
    <nav class="row navbar">
      <a v-if="userLoggedIn" class="button" @click="logout">Logout</a>
      <router-link v-if="!userLoggedIn" class="button" to="/login">Login</router-link>
      <router-link v-if="userLoggedIn" class="button" to="/account">Account</router-link>
      <router-link class="button" to="/about">About</router-link>
      <router-link class="button" to="/galaxy">Galaxy</router-link>
      <router-link class="button" to="/todo">To-Do</router-link>
      <router-link v-if="userLoggedIn" class="button" to="/email">Email</router-link>
      <a class="button" href="https://api.omnomzom.com/rss.php">RSS</a>
    </nav>
    <hr class="navbar-seperator" id="content-top">
  </div>
</template>

<script>
export default {
  computed: {
    userLoggedIn () {
      return this.$store.state.user !== null
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('logoutUser', {})
    }
  }
}
</script>

<style scoped>

/* Header */
h1 {
  text-align: center;
  font-family: "Unica One";
  font-size: 5em;
}

h1 a {
  color: #111;
  text-decoration: none;
  transition: color 300ms ease-out;
}

h1 a:hover {
  color: white;
}

/* Navbar */
.navbar {
  text-align: center;
}

.navbar a {
  padding: 0 1rem;
}

</style>



// WEBPACK FOOTER //
// SiteHeader.vue?1fe5ce39